import { network } from './network';
import { UsageGroup, UsageReport, UsageTrend } from '../types/firstWeekTypes';

const getReport = (group: UsageGroup, from: string, to: string) =>
  network.get<UsageReport>('/admin/usage', { group, from, to });

const getTrend = (group: UsageGroup, event: string, from: string, to: string) =>
  network.get<UsageTrend>('/admin/usage/trend', { group, event, from, to });

export const usageApi = { getReport, getTrend };
